module ValTools {
	export function valWithChange(element: JQuery<HTMLElement>, newVal: string | number | string[]) {
		const oldVal = element.val();
		if (oldVal !== newVal) {
			element.val(newVal);
			element.change();
		}
	}
}